import * as React from 'react';
import URI from 'urijs';

import CurrentUser from 'auth/CurrentUser';
import Image from 'components/Image';
import Text from 'components/Text';
import Link from 'components/Link';
import Row from 'components/Row';
import openUrl from 'utils/openUrl';
import VideoPlayer from 'components/VideoJS';

import './styles/MessageItemLinkPreview.scss';
import '../../../node_modules/video.js/dist/video-js.min.css';

type Props = {
  linkPreview: {
    url: string;
    title?: string;
    description?: string;
    imageUrl?: string;
    imageWidth?: number | null;
    imageHeight?: number | null;
    richContentType?: string;
    richContentUrl?: string;
  };
};

const MessageItemLinkPreview = (props: Props) => {
  const { linkPreview } = props;
  const richContent = renderRichContent(props);

  return (
    <div className="MessageItemLinkPreview">
      {richContent}
      <div className="MessageItemLinkPreview-card">
        {linkPreview.imageUrl && !richContent ? (
          <Link
            className="MessageItemLinkPreview-card-thumbnail"
            onClick={() => openUrl(linkPreview.url)}>
            <Image
              className="MessageItemLinkPreview-card-thumbnail-image"
              src={linkPreview.imageUrl}
            />
          </Link>
        ) : null}
        <div className="MessageItemLinkPreview-card-text">
          <Row size="xsmall">
            <Link onClick={() => openUrl(linkPreview.url)}>
              <Text
                className="MessageItemLinkPreview-card-text-title"
                size="xsmall"
                truncate
                weight="semibold"
                wrap={false}
                color="brand"
                align="left">
                {linkPreview.title || linkPreview.url}
              </Text>
            </Link>
            {linkPreview.title &&
              linkPreview.description && (
                <Text color="eclipse" size="xxxsmall" truncate wrap={false}>
                  {linkPreview.description}
                </Text>
              )}
          </Row>
          <Text color="koala" size="xxxxxsmall">
            {getHostForUrl(linkPreview.url)}
          </Text>
        </div>
      </div>
    </div>
  );
};

const renderRichContent = (props: Props) => {
  const { linkPreview } = props;

  const currentUser = CurrentUser.getUser();
  const mp4Enabled = currentUser && currentUser.hasFeature('rich_content_previews.mp4.web');

  if (mp4Enabled && linkPreview.richContentType === 'video/mp4') {
    return renderVideoPlayer(props);
  }

  return null;
};

const renderVideoPlayer = (props: Props) => {
  const { linkPreview } = props;

  if (!linkPreview.richContentType || !linkPreview.richContentUrl) {
    return null;
  }

  const sizeStyle =
    linkPreview.imageWidth && linkPreview.imageHeight
      ? {
          width: `${linkPreview.imageWidth}px`,
          height: `${linkPreview.imageHeight}px`,
        }
      : {};

  return (
    <div className="MessageItemLinkPreview-video" style={sizeStyle}>
      <VideoPlayer
        poster={linkPreview.imageUrl}
        autoplay={false}
        controls={true}
        controlBar={{
          children: [
            'playToggle',
            'currentTimeDisplay',
            'timeDivider',
            'durationDisplay',
            'progressControl',
            'volumePanel',
            'fullscreenToggle',
          ],
        }}
        sources={[
          {
            type: linkPreview.richContentType,
            src: linkPreview.richContentUrl,
          },
        ]}
      />
    </div>
  );
};

const getHostForUrl = (url: string) => {
  return URI(url).hostname() || URI(`http://${url}`).hostname();
};

export default MessageItemLinkPreview;
